import request from '@/api/request';
const applogRequest = request(process.env.APPLOGS_API);

export function getActionLog (params) {
  return applogRequest({
    url: 'api/ActionLog',
    method: 'get',
    params
  });
}


// WEBPACK FOOTER //
// ./src/api/applog.js